import React from "react";
import {useTranslation} from "react-i18next";
import {SpanView} from "./HtmlView";
import {IQuoteContentBlock} from "@webng-types/write-model";
import {safeLinkUrl} from "../converter/safeUrl";

export function QuoteContentBlockView({block} : {block: IQuoteContentBlock}) {
  const {t,i18n} = useTranslation('liveblog')

  // The source is agent/editor/feed-authored and lands in an href; React does not block a
  // `javascript:` href, so validate it (see safeLinkUrl) and only link when it is safe.
  const sourceHref = safeLinkUrl(block.source)

  return <div className="tik4-quote">
    <blockquote className="tik4-quote__blockquote">
      <div className={`tik4-quote__text tik4-quote__text--${i18n.language} tik4-rich-text tik4-rich-text--${i18n.language}`}>
        <span className="tik4-quote__quotation-mark tik4-quote__quotation-mark--open">{t('liveblog.quote.quotation_mark.open')}</span><SpanView className="tik4-quote__text-content" html={block.text || ""} /><span className="tik4-quote__quotation-mark tik4-quote__quotation-mark--close">{t('liveblog.quote.quotation_mark.close')}</span>
      </div>
      {block.author &&
        <cite className={`tik4-quote__cite ${ sourceHref ? 'tik4-quote__cite--source' : ''}`}>
          { sourceHref ?
              <a className="tik4-quote__cite__source tik4-link tik4-link--muted" href={sourceHref} target="_blank" rel="noopener">{block.author}</a>
            :
              block.author
          }
        </cite>
      }
    </blockquote>
  </div>
}
